module.exports = "/assets/9b5ba409427cdd98b3a3ca6d1f6d8704.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BE.png
// module id = 1227
// module chunks = 0